export const eventHandlers = {
  PRODUCT_SEARCH_RESULTS_PAGE_VIEW: 'PRODUCT_SEARCH_RESULTS_PAGE_HIT',
  PRODUCT_SEARCH_RESULTS_SEARCH: 'PRODUCT_SEARCH_RESULTS_SEARCH_ASSISTANT',
  SELECT_ITEM_PRODUCT_SEARCH_RESULTS: 'SELECT_ITEM_PRODUCT_SEARCH_RESULTS_CLICK',
};
